import http from 'hub-http/clients/apiClient';
import httpNoAuth from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
export const isQAProxy = window.location.hostname.indexOf('wthubspot') >= 0;
const BASE_URL = 'monetization/v3/direct-to-buy'; // Internal only

export const createDTBConfig = dtbConfig => {
  return http.post(BASE_URL, {
    data: dtbConfig
  });
};
export const createDTBConfigPublic = dtbConfig => {
  const url = `${getFullUrl('app-api', isQAProxy ? {
    envOverride: 'qa'
  } : {})}/${BASE_URL}/public`;
  return httpNoAuth.post(url, {
    data: dtbConfig
  });
};
export const getDTBConfigById = dtbConfigId => {
  return http.get(`${BASE_URL}?id=${dtbConfigId}`);
}; // Internal only

export const deleteDTBConfig = dtbConfigId => {
  return http.delete(`${BASE_URL}?id=${dtbConfigId}`);
}; // Internal only

export const updateDTBConfig = (dtbConfigId, dtbConfig) => {
  return http.put(`${BASE_URL}?id=${dtbConfigId}`, {
    data: dtbConfig
  });
};